import { ref, reactive, toRefs, computed } from '@vue/composition-api'
import qs from 'qs' //why qs? https://github.com/axios/axios#using-applicationx-www-form-urlencoded-format
import axios from 'axios'
import useCart from '../composables/useCart'
import useShipping from '../composables/useShipping'
import useBilling from '../composables/useBilling'

//make this state variable global
let checkout
let checkoutUser

export default function useCheckout() {
  if (checkout == undefined) {
    checkout = reactive(window.checkout)
    /*
            itemList: arguments.itemList,
            addresses: {
                shipping: shipAddr,
                billing: {
                    ID: "new",
                    NAME: "",
                    ORGANIZATION: "",
                    ADDRESS: "",
                    CITY: "",
                    STATE: "",
                    POSTAL: "",
                    COUNTRY: "",
                    SEQUENCE: "",
                    VALID: false
                }
            },
            pricing: SESSION.cart.pricing,
            packages: "",
            tax: SESSION.cart.tax,
            info: {
                uuid: arguments.cartId,
                taxShip: false,
                market: application.site.cart.getUserMarketInfo(),
                review: { required: false },
                payType: "",
                estShipDate: ""
            },
            reqPricing: SESSION.cart.reqPricing,
            cardOptions: application.site.checkout.getCards(),
            orderProcessed: {}
        */
  }

  if (checkoutUser == undefined) {
    checkoutUser = ref(window.checkoutUser)
  }

  const { getCart } = useCart()

  const getMsgFromEcode = (eCode) => {
    const params = qs.stringify({
      eCode: eCode,
    })

    return axios.post('/actions/checkout.cfc?method=getMsgFromEcode', params)
  }

  const submit = () => {
    const { shipMethod, methods, shippingSet, shipNotes } = useShipping()
    const { method: paymentMethod, po, card } = useBilling()

    const shipInfo = {
      shipMethod: shipMethod.value,
      methods: methods.value,
      shippingSet: shippingSet.value,
      shipNotes: shipNotes.value,
    }

    const params = new URLSearchParams(
      qs.stringify({
        addresses: JSON.stringify(checkout.addresses),
        pricing: JSON.stringify(checkout.pricing),
        paymentMethod: paymentMethod.value,
        po: JSON.stringify(po.value),
        shipInfo: JSON.stringify(shipInfo),
        card: JSON.stringify(card.value),
        tax: JSON.stringify(checkout.tax),
        market: JSON.stringify(checkout.info.market),
      })
    )

    return axios.post('/actions/checkout.cfc?method=submitOrder', params)
  }

  const clearTaxAndShipping = () => {
    const { clearShipping } = useShipping()
    checkout.pricing.tax = 0
    checkout.pricing.ship = 0
    checkout.tax = {}
    clearShipping()
  }

  const clearOrderProcessed = () => {
    checkout.orderProcessed = {}
  }

  const orderComplete = () => {
    //need to clear out checkout and possibly cart items...
    if (!checkout.info.isQuote) {
      //clear cart
      getCart()
    }

    clearCheckout()
  }

  const clearCheckout = () => {
    axios
      .post('/actions/checkout.cfc?method=initCheckout')
      .then((resp) => {
        window.checkout = resp.data
        //retain this so we retain deatils on the order that was completed
        window.checkout.orderProcessed = checkout.orderProcessed
        checkout = reactive(window.checkout)
      })
      .catch((error) => {
        //not sure we need to show user anything here...
        console.log(error)
      })
  }

  const calculateTax = async () => {
    if (!checkout.info.isQuote) {
      // var taxTotal = 0;
      const checkoutData = window.checkout
      const checkoutUser = window.checkoutUser
      if (window.sureTax != undefined) {
        const sureTaxAdd = window.sureTax.validatedAddress
        const enteredAddress = window.enteredAddress

        let items = window.checkout.itemList
        const sanitizeAddress = (address) => address.replace(/[^a-zA-Z0-9]/g, '')

        const sanitizedSureTaxAdd = sanitizeAddress(sureTaxAdd?.PrimaryAddressLine || '')
        const sanitizedEnteredAddress = sanitizeAddress(enteredAddress?.PrimaryAddressLine || '')
        const today = new Date()
        const month = today.getMonth() + 1
        const day = today.getDate()
        const year = today.getFullYear()
        const formattedDate = `${month}/${day}/${year}`
        const data = {
          DataYear: new Date().getFullYear().toString(),
          DataMonth: (new Date().getMonth() + 1).toString(),
          // BusinessUnit: checkoutData.shipping.ORGANIZATION,
          CmplDataYear: new Date().getFullYear().toString(),
          CmplDataMonth: (new Date().getMonth() + 1).toString(),
          TotalRevenue: checkoutData.pricing.total.toFixed(4).toString(),
          ReturnFileCode: 'Q',
          ClientTracking: 'TEST',
          ResponseType: '25D',
          STAN: '',
          MasterTransID: '',
          InvoiceNumber: '',
          ItemList: items.map((item, index) => ({
            LineNumber: `${index + 1}`,
            InvoiceNumber: '',
            CustomerNumber: `${checkoutUser.custInfo.customer.primary.eid}${checkoutUser.custInfo.customer.primary.purchase}`,
            // LocationCode: sureTaxAdd?.GeoCode || enteredAddress?.GEOCODE,
            LocationCode: 'US08013A0029',
            TransDate: formattedDate,
            Revenue: item.itemPrice?.replace(/[$,]/g, ''),
            Units: item.mainqty,
            TaxIncludedCode: '0',
            TaxSitusRule: '22',
            TransTypeCode: '990101',
            SalesTypeCode: 'T',
            RegulatoryCode: '70',
            TaxExemptionCodeList: ['00'],
            ExemptReasonCode: '',
            AuxRevenue: '0',
            AuxRevenueType: '',
            RuleOverride: '',
            CostCenter: '',
            GLAccount: '',
            MaterialGroup: '',
            Parameter1: '',
            Parameter2: '',
            Parameter3: '',
            Parameter4: '',
            Parameter5: '',
            Parameter6: '',
            Parameter7: '',
            Parameter8: '',
            Parameter9: '',
            Parameter10: '',
            CurrencyCode: '',
            UDF: '',
            UDF2: '',
            ShipToAddress: {
              primaryAddressLine: sanitizedSureTaxAdd || sanitizedEnteredAddress,
              SecondaryAddressLine: sureTaxAdd?.SecondaryAddressLine,
              // County: sureTaxAdd.County,
              City: sureTaxAdd?.City || enteredAddress?.CITY,
              State: sureTaxAdd?.State || enteredAddress?.STATE,
              PostalCode: sureTaxAdd?.ZIPCode || enteredAddress?.POSTAL,
              Plus4: sureTaxAdd?.ZIPPlus4 || '',
              // Country: sureTaxAdd.Country,
            },
          })),
        }

        // Convert the ItemList data to a JSON string
        const itemListJSON = JSON.stringify(data.ItemList)
        // const itemListJSON = data.ItemList;
        // Call the calculateTax method in suretax.cfc with the necessary arguments
        const result = await fetch('/actions/suretax.cfc?method=calculateTax', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: `DataYear=${encodeURIComponent(data.DataYear)}&DataMonth=${encodeURIComponent(
            data.DataMonth
          )}&BusinessUnit=${encodeURIComponent(
            data.BusinessUnit
          )}&CmplDataYear=${encodeURIComponent(
            data.CmplDataYear
          )}&CmplDataMonth=${encodeURIComponent(
            data.CmplDataMonth
          )}&TotalRevenue=${encodeURIComponent(
            data.TotalRevenue
          )}&ReturnFileCode=${encodeURIComponent(
            data.ReturnFileCode
          )}&ClientTracking=${encodeURIComponent(
            data.ClientTracking
          )}&ResponseType=${encodeURIComponent(data.ResponseType)}&STAN=${encodeURIComponent(
            data.STAN ? data.STAN : null
          )}&MasterTransID=${encodeURIComponent(
            data.MasterTransID
          )}&InvoiceNumber=${encodeURIComponent(
            data.InvoiceNumber
          )}&ItemListJSON=${encodeURIComponent(itemListJSON)}`,
        })
        if (result.ok) {
          try {
            const responseJson = await result.json()
            const response = responseJson.response
            const code = response.ResponseCode
            switch (code) {
              case '9999':
                checkout.pricing.tax = parseFloat(response.TotalTax)
                break
              case '9001':
                alert(`Success with errors - Code: ${code} - Message: ${response.HeaderMessage}`)
                break
              case code >= '1101' && code <= '1400':
                alert(`Error: Invalid input - Code: ${code} - Message: ${response.HeaderMessage}`)
                break
              default:
                alert(`Unknown Error - Code: ${code} - Message: ${response.HeaderMessage}`)
                break
            }
            // checkout.pricing.tax = response.TotalTax;
          } catch (error) {
            console.error('Error parsing JSON:', error)
            return error
          }
        } else {
          console.error('Request failed with status:', result.status)
        }
      }
      // checkout.pricing.tax = taxTotal;
    }
  }
  return {
    ...toRefs(checkout),
    checkoutUser,
    getMsgFromEcode,
    submit,
    clearTaxAndShipping,
    clearOrderProcessed,
    total: computed(() => checkout.pricing.total + checkout.pricing.tax + checkout.pricing.ship),
    calculateTax,
    orderComplete,
  }
}
